import { Pagination } from 'flowbite-react';

const CustomPagination = ({ currentPage, totalPages, onPageChange, t }) => {
    return (
        <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            previousLabel={t('table.paginationPrevious')}
            nextLabel={t('table.paginationNext')}
            theme={{
                base: '',
                layout: {
                    table: {
                        base: 'text-xs md:text-sm text-primary',
                        span: 'text-white font-semibold '
                    },
                },
                pages: {
                    base: 'inline-flex items-center',
                    showIcon: 'inline-flex',
                    previous: {
                        base: `
                            h-8 px-2 py-1 rounded-l border border-platinum text-grayX11
                            enabled:hover:outline-none enabled:hover:border-none enabled:hover:bg-gradient-to-r enabled:hover:from-primary enabled:hover:via-primary enabled:hover:to-secondary enabled:hover:text-white enabled:hover:font-medium
                            enabled:focus:outline-none enabled:focus:border-none enabled:focus:bg-gradient-to-r enabled:focus:from-primary enabled:focus:to-primary enabled:focus:text-white enabled:focus:font-medium
                        `,
                        icon: 'h-4 w-4'
                    },
                    next: {
                        base: `
                            h-8 px-2 py-1 rounded-r border border-platinum text-grayX11
                            enabled:hover:outline-none enabled:hover:border-none enabled:hover:bg-gradient-to-r enabled:hover:from-primary enabled:hover:via-primary enabled:hover:to-secondary enabled:hover:text-white enabled:hover:font-medium
                            enabled:focus:outline-none enabled:focus:border-none enabled:focus:bg-gradient-to-r enabled:focus:from-primary enabled:focus:to-primary enabled:focus:text-white enabled:focus:font-medium
                        `,
                        icon: 'h-4 w-4'
                    },
                    selector: {
                        base: `
                            h-8 w-8 p-1 border border-platinum text-grayX11
                            enabled:hover:outline-none enabled:hover:border-none enabled:hover:bg-gradient-to-r enabled:hover:from-primary enabled:hover:via-primary enabled:hover:to-secondary enabled:hover:text-white enabled:hover:font-medium
                            enabled:focus:outline-none enabled:focus:border-none enabled:focus:bg-gradient-to-r enabled:focus:from-primary enabled:focus:to-primary enabled:focus:text-white enabled:focus:font-medium
                        `,
                        active: 'outline-none border-none bg-gradient-to-r from-primary to-secondary text-white font-medium',
                        disabled: 'cursor-not-allowed opacity-50'
                    },
                },
            }}
        />
    );
};

export default CustomPagination;
